import { render, staticRenderFns } from "./SendPurchaseRequest.vue?vue&type=template&id=4f03089f&"
import script from "./SendPurchaseRequest.vue?vue&type=script&lang=ts&"
export * from "./SendPurchaseRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports